module.exports = __webpack_public_path__ + "media/images/CMFerreiraZezere-ac8a97dde887880c977e2821f4c7cc63.jpeg";